let popupShown = false;

function showPopup() {
  if (popupShown) return;
  popupShown = true;

  const popup = document.querySelector('#shopify-pc__banner.shopify-pc__banner__dialog');
  if (popup) {
    popup.style.opacity = '1';
    popup.style.visibility = 'visible';
    popup.style.pointerEvents = 'auto';
  }
}
showPopup();